"use client";

import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { SafeDiveCenter } from "../types";
import '../../app/globals.css'

// @ts-ignore
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: markerIcon.src,
  iconRetinaUrl: markerIcon2x.src,
  shadowUrl: markerShadow.src,
});

interface MapProps {
  center?: number[];
  diveCenter?: SafeDiveCenter | null;
  latitude: number;
  longitude: number;
}


const url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
const attribution =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

const MapWithCoordinates: React.FC<MapProps> = ({ diveCenter, latitude, longitude }) => {

    return (
    <div className="h-[35vh] rounded-lg">
      <MapContainer
    //    center={(center as L.LatLngExpression) || [51, -0.09]}
        center={[diveCenter?.latitude || latitude, diveCenter?.longitude || longitude]}
        // zoom={diveCenter?.latitude !== 0 && diveCenter?.longitude !== 0 ? 12 : 2}
        zoom={3}
        scrollWheelZoom={false}
        className="h-full"
        style={{ zIndex: 0 }} 
      >
        <TileLayer url={url} attribution={attribution} />
        <Marker position={[diveCenter?.latitude || latitude, diveCenter?.longitude || longitude]}>
          <Popup>{diveCenter?.user?.name || ""}</Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default MapWithCoordinates;